// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ALvx","colMin":"styles_colMin__1ZP7e"};